module.exports = __webpack_public_path__ + "img/chat.bd842714.svg";